export const ExportTypes = {
  Created: 0,
  Exporting: 1,
  Succeeded: 2,
  Failed: 3,
} as const;

export const ImportTypes = {
  Created: 0,
  Parsing: 1,
  ParsingFailed: 2,
  ReadyToImport: 3,
  Importing: 4,
  ImportFailed: 5,
  ImportSuccess: 6,
} as const;

export type ExportType = typeof ExportTypes[keyof typeof ExportTypes];
